module.exports = require("detect-passive-events");